import { NumericMenuItem } from '@/vibes/mom/sections/faceted-product-list/types';

export const BASE_PRICE_POINTS = [0, 50, 100, 200, 400] as const;

export const defaultPriceFilters: NumericMenuItem[] = [
  // TODO: Add translation
  { label: 'Show all' },
  { label: '£0 - £50', end: 50 },
  { label: '£50 - £100', start: 50, end: 100 },
  { label: '£100 - £200', start: 100, end: 200 },
  { label: '£200 - £400', start: 200, end: 400 },
  { label: '£400+', start: 400 },
];

export const ratingsFilters: NumericMenuItem[] = [
  // TODO: Add translation
  { label: 'Show all' },
  { label: '5 ⭐ only', start: 5 },
  { label: '4 ⭐ and up', start: 4, end: 5 },
  { label: '3 ⭐ and up', start: 3, end: 5 },
  { label: '2 ⭐ and up', start: 2, end: 5 },
  { label: '1 ⭐ and up', start: 1, end: 5 },
];

export const resultPerPageOptions = [
  {
    label: '30',
    value: 30,
    default: true,
  },
  {
    label: '45',
    value: 45,
  },
  {
    label: '75',
    value: 75,
  },
];

export const defaultHitsPerPage = resultPerPageOptions.find((item) => item.default)?.value || 30;
